import { render, staticRenderFns } from "./GuidewirePolicyCoverages.vue?vue&type=template&id=0b433031"
import script from "./GuidewirePolicyCoverages.vue?vue&type=script&lang=js"
export * from "./GuidewirePolicyCoverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports